import { useUser } from "@features/user/use-user";
import { useEffectPlease } from "@features/utils";
import { Spinner } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";

let checkPlanUpdateInterval: NodeJS.Timeout = 0 as any;

export default function PlanPage() {
  const { user } = useUser();
  const urlParams = new URLSearchParams(window.location.search);
  const plan = urlParams.get("plan")?.split("_")[0]; // "basic_yearly" -> "basic"
  const interval = urlParams.get("plan")?.includes("_yearly")
    ? "year"
    : "month";
  const returnedFromStripe = !!urlParams.get("stripe");
  const navigate = useNavigate();

  useEffectPlease(() => {
    if (user.data?.email && !returnedFromStripe) {
      navigate("/billing");
    }

    if (returnedFromStripe) {
      checkPlanUpdateInterval = setInterval(() => {
        user.refetch();
      }, 1000);
    }

    return () => {
      clearInterval(checkPlanUpdateInterval);
    };
  }, [user.data?.email, user.data?.id, plan, interval, returnedFromStripe]);

  if (returnedFromStripe) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner />
      </div>
    );
  }

  return <></>;
}
